export default __webpack_public_path__ + "static/media/presentation.80286c8d.png";